import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const SuccessfullyEntered = ({ title }) => (
    <Styled.Text>
        You have successfully entered into the{' '}
        <Styled.Highlighted>{title} Sweepstake</Styled.Highlighted> competition!
    </Styled.Text>
);

SuccessfullyEntered.propTypes = {
    title: PropTypes.string.isRequired
};

export default SuccessfullyEntered;
